const captchaSelector = '.captcha-c';
const version = '1.0.0';

var captcha_audio = null;
var first_captcha_generated = false;

export default class CaptchaInput{
    static init(){
        $(captchaSelector).each(function (index, element) {
            if(element.captcha_instance) return;
            element.captcha_instance = new CaptchaInput(element);
        });
    }

    constructor(element) {
        let that = this;
        this.element = element;
        let $element = this.$element = $(element);
        console.log("CaptchaInput ("+version+") inited for:", element)

        let $input = $element.find('input.captcha-input');
        let $img = this.$img = $element.find('img.captcha-image');
        let $audioBtn = this.$audioBtn = $element.find('.input-actions > a.btn.play');
        let $refreshBtn = $element.find('.input-actions > a.btn.refresh');

        if($audioBtn)
        {
            $audioBtn.data('autoplay', false);
            $audioBtn.on('click', function (e) {
                $audioBtn.data('autoplay', true);
                if(that.captcha_image_source_exist()){
                    that.captcha_play_captcha_audio();
                }
            });
            $img.on('load', function (e) {
                if ($audioBtn.data('autoplay')) {
                    that.captcha_play_captcha_audio();
                }
            });
        }

        $input.on('focus', function (e) {
            if($element.data('generated')) return;
            that.captcha_image_source_exist($img);
        });
        $img.on('mouseover', function (e) {
            if($element.data('generated')) return;
            that.captcha_image_source_exist($img);
        });

        let $collapseWrap = $img.closest('.collapse');
        if($collapseWrap.length){
            $collapseWrap.on('shown.bs.collapse', function () {
                if($element.data('generated')) return;
                that.captcha_image_source_exist($img);
            })
        }

        if($refreshBtn){
            $refreshBtn.on('click', function (e) {
                that.doRefresh();
            });
        }

        $element.data('refresh', function () {
            that.doRefresh();
        });

        if(!first_captcha_generated && $element.is(":visible")){
            first_captcha_generated = true;
            this.captcha_image_source_exist();
        }
    }

    doRefresh(){
        this.$img.attr('src', $img.data('src') + Math.round(Math.random()*10))
        if(captcha_audio){
            captcha_audio.pause();
            captcha_audio = null;
            if($audioBtn){
                $audioBtn.find('i.fa').addClass('fa-play-circle-o').removeClass('fa-circle-o-notch fa-spin');
            }
        }
    }
    captcha_image_source_exist() {
        if(captcha_audio){
            captcha_audio.pause();
            captcha_audio = null;
        }

        console.log(this.$img);

        if(this.$img.attr('src') === '/Framework/assets/images/captcha-preview.jpg'){
            $("img.captcha-image").attr('src', '/Framework/assets/images/captcha-preview.jpg')
            this.$img.attr('src', this.$img.data('src'));
            this.$element.data('generated', true);
            return false;
        }
        return true;
    }

    captcha_play_captcha_audio() {

        if(captcha_audio){
            captcha_audio.pause();
            captcha_audio = null;
        }

        var audioUrl = baseHref  + 'general/captcha_play_audio/r.' + Math.random();
        captcha_audio = new Audio(audioUrl);
        captcha_audio.play();

        $(captcha_audio).on('ended', function (e) {
            this.$audioBtn.find('i.fa').addClass('fa-play-circle-o').removeClass('fa-circle-o-notch fa-spin');
        })

        this.$audioBtn.find('i.fa').removeClass('fa-play-circle-o').addClass('fa-circle-o-notch fa-spin');
        this.$audioBtn.data('autoplay', false);
    }
}

CaptchaInput.init();

/*
$(function(){
    captcha_init();
});

var captcha_audio = null;
var first_captcha_generated = false;

function captcha_image_source_exist($img) {
    if(captcha_audio){
        captcha_audio.pause();
        captcha_audio = null;
    }

    if($img.attr('src') == '/Framework/assets/images/captcha-preview.jpg'){
        $("img.captcha-image").attr('src', '/Framework/assets/images/captcha-preview.jpg')
        $img.attr('src', $img.data('src'));
        $img.parents('.captcha-c').data('generated', true);
        return false;
    }
    return true;
}
function captcha_play_captcha_audio($audioBtn) {

    if(captcha_audio){
        captcha_audio.pause();
        captcha_audio = null;
    }

    var audioUrl = baseHref  + 'general/captcha_play_audio/r.' + Math.random();
    captcha_audio = new Audio(audioUrl);
    captcha_audio.play();

    $(captcha_audio).on('ended', function (e) {
        $audioBtn.find('i.fa').addClass('fa-play-circle-o').removeClass('fa-circle-o-notch fa-spin');
    })

    $audioBtn.find('i.fa').removeClass('fa-play-circle-o').addClass('fa-circle-o-notch fa-spin');
    $audioBtn.data('autoplay', false);
}

function captcha_init() {

    $('.captcha-c').each(function (index) {
        var $that = $(this);
        if($that.data('inited')) return;

        var $input = $(this).find('input.captcha-input');
        var $img = $(this).find('img.captcha-image');
        var $audioBtn = $(this).find('.input-actions > a.btn.play');
        var $refreshBtn = $(this).find('.input-actions > a.btn.refresh');
        var doRefresh = function () {
            $img.attr('src', $img.data('src') + Math.round(Math.random()*10))
            if(captcha_audio){
                captcha_audio.pause();
                captcha_audio = null;
                if($audioBtn){
                    $audioBtn.find('i.fa').addClass('fa-play-circle-o').removeClass('fa-circle-o-notch fa-spin');
                }
            }
        }

        if($audioBtn)
        {
            $audioBtn.data('autoplay', false);
            $audioBtn.on('click', function (e) {
                $audioBtn.data('autoplay', true);
                if(captcha_image_source_exist($img)){
                    captcha_play_captcha_audio($audioBtn);
                }
            });
            $img.on('load', function (e) {
                if ($audioBtn.data('autoplay')) {
                    captcha_play_captcha_audio($audioBtn);
                }
            });
        }

        $input.on('focus', function (e) {
            if($that.data('generated')) return;
            captcha_image_source_exist($img);
        });
        $img.on('mouseover', function (e) {
            if($that.data('generated')) return;
            captcha_image_source_exist($img);
        });

        $collapseWrap = $img.closest('.collapse');
        if($collapseWrap.length){
            $collapseWrap.on('shown.bs.collapse', function () {
                if($that.data('generated')) return;
                captcha_image_source_exist($img);
            })
        }

        if($refreshBtn){
            $refreshBtn.on('click', function (e) {
                doRefresh();
            });
        }
        $that.data('inited', true);
        $that.data('refresh', function () {
            doRefresh();
        });

        if(!first_captcha_generated && $(this).is(":visible")){
            first_captcha_generated = true
            captcha_image_source_exist($img);
        }
    });
}

 */